// extracted by mini-css-extract-plugin
export default {"input":"auto-complete_input__hF2cE","suggestion":"auto-complete_suggestion__+GeNU","listItem":"auto-complete_listItem__7xAQX"};